import styled from 'styled-components';
import { Typ10 } from 'dc/Typ';
import Ico24 from 'dc/Ico24';
import Ava24 from 'dc/Ava24';
import Act24 from 'dc/Act24';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 48px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  background-color: transparent;
`;

export const Position = styled(Typ10)`
  text-align: center;
  width: 32px;
  color: ${props => (props.userPosition ? '#263238' : '#607d8b')};
  font-weight: ${props => (props.userPosition ? 'bold' : null)};
`;

export const Icon = styled(Ico24)`
  margin-right: 12px;
  color: ${props => (props.color ? props.color : '#90a4ae')};
`;

export const Avatar = styled(Ava24)`
  margin-right: 12px;
`;

export const ActivityIcon = styled(Act24)`
  margin-right: 12px;
`;
